import { ReactNode } from 'react'
import styled, { css } from 'styled-components'

import { Nullable } from 'shared/utils/type-guards'

import { SIZES } from '~/common/globalStyles'
import { DisplayOrganizationType } from '~/common/types/graphql'
import CollaborationLogos from '~/views/components/CollaborationLogos'
import Logo from '~/views/components/Logo'
import Card from '~/views/components/ui/Card'
import Text from '~/views/components/ui/Text'

interface StyledLogoCardProps {
  padding?: keyof typeof SIZES
  width?: number | string
}

const StyledLogoCard = styled(Card)<StyledLogoCardProps>`
  padding: ${(props) =>
    props.padding ? `${SIZES[props.padding]};` : `${SIZES.huge};`};
  display: flex;
  flex-direction: column;
  margin-top: ${SIZES.xxl};
  ${({ width }) => css`
    width: ${`${width}${typeof width === 'number' ? 'px' : ''}`};
  `};
`

const LogoWrapper = styled.div`
  opacity: 0.3;
`

const StyledCollaborationLogos = styled(CollaborationLogos)`
  justify-content: center;
  margin-bottom: ${SIZES.xxxl};
`

interface Props {
  children: ReactNode
  poweredByLogo?: boolean
  collaboration?: Nullable<{
    provider?: DisplayOrganizationType | null
    customer?: Nullable<{
      id: string
      name: string
      logo?: Nullable<{ originalUrl?: string | null }>
    }>
  }>
  width?: number | string
  padding?: keyof typeof SIZES
}

const LogoCard = ({
  poweredByLogo = true,
  collaboration,
  width,
  padding,
  children,
}: Props) => {
  return poweredByLogo || collaboration ? (
    <StyledLogoCard width={width} padding={padding}>
      {collaboration && (
        <StyledCollaborationLogos
          provider={collaboration.provider}
          customer={collaboration.customer}
          labels={{
            provider: 'Provider',
            customer: 'Customer',
          }}
        />
      )}
      {children}
      <div
        style={{
          width: '100%',
          textAlign: 'center',
          marginTop: SIZES.xxl,
        }}
      >
        <LogoWrapper>
          <Text>Powered by</Text>
          <br />
          <Logo height="32" />
        </LogoWrapper>
      </div>
    </StyledLogoCard>
  ) : (
    <StyledLogoCard width={width} padding={padding}>
      <div
        style={{
          width: '100%',
          textAlign: 'center',
          marginBottom: SIZES.xxl,
        }}
      >
        <Logo height="32" />
      </div>
      {children}
    </StyledLogoCard>
  )
}

export default LogoCard
